"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormatter = void 0;
const isString_1 = __importDefault(require("lodash-es/isString"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const date_1 = require("./mixins/date");
class TimeFormatter extends date_1.DateFormatterMixin {
    transform(time, timeFormat = "hh:mm A", language, timezone) {
        if (!time) {
            return "";
        }
        const format = this.getTimeFormat(timeFormat);
        // convert string date to Moment date object
        if ((0, isString_1.default)(time)) {
            time = this.getTime(time);
        }
        if (language) {
            time = (0, moment_timezone_1.default)(time).locale(language);
        }
        if (timezone) {
            const tz = (0, moment_timezone_1.default)(time).tz(timezone);
            return `${tz.format(format)}`;
        }
        return time.format(format);
    }
}
exports.TimeFormatter = TimeFormatter;
